import React, { useEffect } from 'react';
import './DocumentsTab.scss';
import { useTranslation } from 'react-i18next';
import useMethodAccount from '../../../MyAccount/hooks/useMethodAccount';
import SingleDocument from './SingleDocument';
import EASkeletonLoader from '../../../shared/EASkeletonLoader';

const SettingsTab: React.FC = () => {
  const { t } = useTranslation();
 
  const { getUserDocuments, docs, loading } = useMethodAccount();

  useEffect(() => {
    getUserDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="tab-content__container">
        <h5>{t('twoje_dokumenty')}</h5>

        <div className="documents-list__container">
          {loading ? <EASkeletonLoader height="120px" /> : (
            docs.length > 0 ? (
              <>
                {docs.map((item, index) => (
                  <SingleDocument document={item} key={index} />
                ))}
              </>
            ) : <p className="text-color-dark-gray">{t('brak_dokumentow')}</p>
          )}
        </div>
    </div>
  );
};

export default SettingsTab;
